<div class="users-container">
  <form action="" [formGroup]="sendId">
    Introduce GUID para borrar el usuario de la base de datos <br><br>
    <input type="text" placeholder="Introduce GUID" formControlName="guid"><br><br>
    <button (click)="deleteUsers()">Eliminar</button>
    <br>
    <p *ngIf="message">{{message}}</p>
  </form>
</div>
